import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import '@/style/news.scss'
import Reveal from '@/components/Reveal'
import { fetchNewsDetailSafe } from '@/api/news'
import sanitize, { stripTags } from '@/utils/sanitize'

function NewsDetail() {
  const { id } = useParams()
  const navigate = useNavigate()
  // 从列表页跳转时带上数据，直接渲染避免二次请求；刷新则回落到接口
  const state = useLocation().state
  const [article, setArticle] = useState(state || null)
  const [loading, setLoading] = useState(!state)

  useEffect(() => {
    if (state?.id === id) return
    let alive = true
    setLoading(true)
    fetchNewsDetailSafe(id).then((data) => {
      if (!alive) return
      setArticle(data)
      setLoading(false)
    })
    return () => {
      alive = false
    }
  }, [id, state])

  const title = article?.msgTitle || '新闻详情'
  const html = sanitize(article?.msgSummary || article?.msgContent)
  const time = article?.releaseTime

  return (
    <article className="newsDetail">
      <header className="newsDetail__head">
        <div className="mainContent">
          <nav className="newsDetail__crumb" aria-label="面包屑">
            <button type="button" onClick={() => navigate('/news')}>新闻中心</button>
            <span>/</span>
            <span className="current">详情</span>
          </nav>
          <h1 className="newsDetail__title">{title}</h1>
          {time && <time className="newsDetail__time">{time}</time>}
        </div>
      </header>

      <div className="mainContent newsDetail__body">
        {loading && <div className="newsDetail__skeleton">
          <div className="sk sk--line" />
          <div className="sk sk--line" />
          <div className="sk sk--line sk--short" />
        </div>}

        {!loading && html && (
          <Reveal className="newsDetail__content" dangerouslySetInnerHTML={{ __html: html }} />
        )}

        {!loading && !html && (
          <div className="noDataBox">
            <i />
            <p>{stripTags(title) ? '正文内容为空' : '未找到该新闻'}</p>
          </div>
        )}

        <div className="newsDetail__foot">
          <button className="btn btn--ghost newsDetail__back" type="button" onClick={() => navigate('/news')}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M13 7H2M6 3L2 7l4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            返回列表
          </button>
        </div>
      </div>
    </article>
  )
}

export default NewsDetail